module.exports = __webpack_public_path__ + "static/img/betNow.12d448f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/betNow.webp
// module id = GtN6
// module chunks = 0